import { render, staticRenderFns } from "./leftSubMenu.vue?vue&type=template&id=9644e8d4&scoped=true"
import script from "./leftSubMenu.vue?vue&type=script&lang=js"
export * from "./leftSubMenu.vue?vue&type=script&lang=js"
import style0 from "./leftSubMenu.vue?vue&type=style&index=0&id=9644e8d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9644e8d4",
  null
  
)

export default component.exports